// eslint-disable-next-line no-undef
const localStorageCart = localStorage.getItem('cart');
export default {
    cart: localStorageCart ? JSON.parse(localStorageCart) : [],
};
